<section [@routerTransition]>
    <div class="row">
        <div class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="input-group d-flex flex-column mr-2">
                <label for="substancia" class="mb-1">Substância ou agente causador</label>
                <div class="input-group">
                    <img class="input-group-text" src="../../../../assets/img/icons/search.svg" alt="Busca">
                    <input id="substancia" type="text" [(ngModel)]="request.substancia" class="busca-nome"
                        (input)="refresh()">
                </div>
            </div>

            <div class="d-flex flex-column mx-2 select-container">
                <label for="tipoAlergia" class="mb-1">Tipo de alergia</label>
                <select class="alergia-select" name="tipoAlergia" id="tipoAlergia" (change)="refresh()"
                    [(ngModel)]="request.tipoAlergia">
                    <option *ngFor="let tipo of tiposAlergias.TiposAlergia" [value]="tipo.type">{{tipo.name}}</option>
                </select>
            </div>
        </div>
        <div class="col p-0 d-flex justify-content-end">
            <button class="btn primary-white-button" (click)="create()">
                Cadastrar
                <i class="hgi hgi-stroke hgi-plus-sign-circle"></i>
            </button>
        </div>
    </div>

    <div class="row">
        <button class="btn btn-filtros" (click)="limparFiltros()">
            Limpar filtros
            <i class="hgi hgi-stroke hgi-delete-02 ml-1"></i>
        </button>
    </div>

    <app-paciente-monitorado [pacienteAtual]="pacienteAtual" [pacienteInicial]="pacienteInicial"
        [temDependentes]="dependentes.length > 0" (selecionarDependente)="selecionarDependentes()"
        (voltarPaciente)="voltarParaPacienteInicial()">
    </app-paciente-monitorado>

    <div class="table-container table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>Criador</th>
                    <th>Substância ou agente causador</th>
                    <th>Tipo de alergia</th>
                    <th>Observação</th>
                    <th>Ação</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="
                let pacienteAlergia of pacienteAlergias
                  | paginate
                    : {
                        id: 'server',
                        itemsPerPage: pageSize,
                        currentPage: pageNumber,
                        totalItems: totalItems
                      }
                ">
                    <td>
                        <div class="btn btn-icon bg-blue-prodiis btn-xs"
                            [title]="pacienteAlergia.creatorUserId && pacienteAlergia.creatorUserId === appSession.userId ? 'Paciente' : 'Profissional da Saúde'">
                            <i
                                [ngClass]="pacienteAlergia.creatorUserId && pacienteAlergia.creatorUserId === appSession.userId ? 'fas fa-user' : 'fas fa-hospital-user'"></i>
                        </div>
                    </td>
                    <td>{{pacienteAlergia.substancia}}</td>
                    <td>{{pacienteAlergia.tipoAlergiaString}}</td>
                    <td>{{pacienteAlergia.observacao}}</td>
                    <td>
                        <div class="row d-flex flex-row">
                            <button class="btn icon icon-edit mr-2" title="Editar alergia do paciente"
                                (click)="edit(pacienteAlergia)">
                                <i class="hgi hgi-stroke hgi-pencil-edit-02"></i>
                            </button>
                            <button class="btn icon icon-danger" title="Apagar alergia do paciente"
                                (click)="delete(pacienteAlergia)">
                                <i class="hgi hgi-stroke hgi-delete-02"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="float-sm-right m-auto">
                <abp-pagination-controls id="server" (pageChange)="getDataPage($event)">
                </abp-pagination-controls>
            </div>
        </div>
    </div>
</section>